<template>
  <div class="row">
    <div class="span8 detail-main">
      <h1 class="post-title">{{ content.help_title }}</h1>
      <div class="post-meta">
        <span>🕐 {{ content.createtime | dataFormat }}</span>
        <span>作者：<author-pop :author="content"></author-pop></span>
        <span>{{ commentnum }} Comments</span>
        <span>👁 66</span>
      </div>
      <blockquote class="post-body" v-html="content.help_content" style="margin: 0 0 20px;"></blockquote>
      <div class="post-tags" v-if="content.help_tag">
        <span class="tags">
          <span v-for="tag in taglist" :key="tag" @click="$router.push('/help/' + tag)">{{ tag }}</span>
        </span>
      </div>
      <!-- 点赞静态占位（原项目无真实点赞接口） -->
      <div style="margin: 24px 0; text-align: center;">
        <el-button round disabled>👍 66</el-button>
      </div>
    </div>
    <div class="span4 page-sidebar">
      <carousel-widget />
      <help-widget />
    </div>
    <div class="span8">
      <comment-widget />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import carouselWidget from '@/components/carousel.vue'
import helpWidget from '@/components/help.vue'
import commentWidget from '@/components/comment.vue'
import authorPop from '@/components/authorpop.vue'
import { getHelpContent } from '@/api'

export default {
  name: 'HelpContent',
  components: { carouselWidget, helpWidget, commentWidget, authorPop },
  props: { id: { type: String, default: '' } },
  data() {
    return { content: {}, taglist: [] }
  },
  computed: {
    ...mapState({ commentnum: (s) => s.commentnum })
  },
  watch: {
    id: { immediate: true, handler() { this.getcontent() } }
  },
  methods: {
    getcontent() {
      if (!this.id) return
      getHelpContent(this.id).then((res) => {
        this.content = res.data || {}
        this.taglist = (this.content.help_tag || '').split(',')
        this.$store.dispatch('setcontentid', this.id)
        this.$store.dispatch('setcontentinfo', { name: this.content.help_title, userid: this.content.user_id })
      })
    }
  }
}
</script>
